module.exports = __webpack_public_path__ + "img/enterprise.dfb1cd49.svg";